/*
 *
 * BaseHeader
 *
 * @version 1.0.0
 * @author Stefano Servodidio
 * @since 19-Nov-2024
 */

import React from 'react'
import PropTypes from 'prop-types'
import PortalLogo from '@nexidigital/portallogo'
import './BaseHeader.scss'

export const BaseHeader = ({ bank, children, className, sx }) => (
  <header className={`baseHeader ${className}`} {...{ sx }}>
    <div className='baseHeaderLogo'>
      <PortalLogo id='headerLogo' bank={bank} />
    </div>
    <div className='baseHeaderContent'>{children}</div>
  </header>
)

BaseHeader.propTypes = {
  // Add here some propTypes
  /** Name of the bank */
  bank: PropTypes.string,
  /** Type of logo (complete or only icon) */
  logoType: PropTypes.string,
  /** This prop is a node. It represents the children that will be displayed on the header menu. */
  children: PropTypes.node,
  /** append custom class */
  className: PropTypes.string,
  /** append custom style */
  sx: PropTypes.object
}

BaseHeader.defaultProps = {
  // Add here some default propTypes values
  bank: 'NEXI',
  logoType: 'dark',
  className: ''
}

export default BaseHeader
